import { Button, Container, Flex, rem, Text, Title } from "@mantine/core";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { getLinearGradient } from "../../mantineTheme";
import classes from "./NotFoundPage.module.css";

function NotFoundPage() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3, delayChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.5 } },
  };

  return (
    <div className={classes.root}>
      <Container size="lg">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <Flex
            direction="column"
            align="center"
            justify="center"
            ta="center"
            style={{ minHeight: "calc(100vh - 240px)" }}
          >
            <motion.div variants={itemVariants}>
              <Title
                order={1}
                style={{
                  fontSize: rem(120),
                  fontWeight: 900,
                  letterSpacing: "-2px",
                  color: "var(--mantine-color-gray-3)",
                }}
              >
                404
              </Title>
            </motion.div>
            <motion.div variants={itemVariants}>
              <Title
                order={2}
                style={{
                  fontSize: rem(40),
                  fontWeight: 900,
                  letterSpacing: "-1px",
                }}
              >
                Page Not Found
              </Title>
            </motion.div>

            <motion.div variants={itemVariants}>
              <Text
                size="xl"
                mt="xl"
                style={{ maxWidth: 600, color: "var(--mantine-color-gray-7)" }}
              >
                Oops! This page doesn't exist. Please return to any of our other
                pages to continue Collabing.
              </Text>
            </motion.div>

            <motion.div variants={itemVariants}>
              <Button
                component={Link}
                to="/"
                size="lg"
                radius="xl"
                mt="xl"
                style={{ background: getLinearGradient("primary") }}
              >
                Go to Homepage
              </Button>
            </motion.div>
          </Flex>
        </motion.div>
      </Container>
    </div>
  );
}

export default NotFoundPage;
